import React from 'react';
export function Footer() {
  return <footer className="bg-ink text-ivory py-16" data-id="element-17">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <div className="text-center max-w-3xl mx-auto" data-id="element-19">
          <h3 className="text-xs tracking-[0.2em] uppercase text-gold font-medium mb-6" data-id="element-20">
            Aviso Importante
          </h3>
          <p className="text-ivory/50 text-sm leading-relaxed mb-12 font-light" data-id="element-21">
            Este material tiene fines exclusivamente educativos e informativos.
            No sustituye la consulta médica, el diagnóstico ni el tratamiento
            indicado por un profesional de la salud. Cualquier decisión
            relacionada con medicamentos o tratamientos debe tomarse junto con
            un médico calificado.
          </p>
          <div className="border-t border-gold/10 pt-12" data-id="element-22">
            <a href="#" className="text-2xl font-serif text-ivory tracking-wide block mb-6" data-id="element-23">
              METABOLIC<span className="text-gold italic" data-id="element-24">Science</span>
            </a>
            <p className="text-ivory/40 text-xs tracking-widest uppercase" data-id="element-25">
              &copy; {new Date().getFullYear()} Metabolic Science. Todos los
              derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}